<template>
  <v-container fluid>
    <v-toolbar class="mb-5">
      <v-select
        v-model="selectedSubjects"
        :items="subjects"
        hide-details
        multiple
        chips
        label="Filter by Subject"
        @change="search"
      ></v-select>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-text-field
        hide-details
        clearable
        label="Enter keywords to search for courses"
        @keydown.enter="search"
        v-model="searchTerms"
      ></v-text-field>
      <v-btn icon @click="search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <app-product-item v-for="prod in products" :item="prod" :key="prod.id"></app-product-item>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProductItem from "../product/ProductItem.vue";

export default {
  data: () => ({
    alignment: "start",
    justify: "start",
    selectedSubjects: ["ELA", "Math"],
    searchTerms: ""
  }),
  components: {
    appProductItem: ProductItem
  },
  computed: {
    ...mapGetters(["products", "subjects"])
  },
  methods: {
    ...mapActions(["updateCart", "addMessage"]),
    addItem() {
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    },
    search() {
      // console.log("filter by subject: " + this.selectedSubjects);
      // console.log("search for " + this.searchTerms);
    }
  },
  created() {
    this.$axios
      .get("public/classroom/open-enrollment-courses")
      .then(resp => {
        this.$store.commit("Update_product_list", resp.data);
      })
      .catch(() => {
        this.addMessage("Error loading courses from server");
      });
  }
};
</script>

<style>
</style>